import { Action } from 'redux';

import { EditFlow } from '../../app/actions/AppActionTypes';
import { IContentInfo } from '../../ts/models/IContentInfo';
import { ISpaceItemDetailInfo } from '../../ts/models/ISpaceItemDetailInfo';

export interface EditFlowReduxAction extends Action {
  readonly flow: IContentInfo;
}

export function editFlow(flow: IContentInfo | ISpaceItemDetailInfo<'flow'>): EditFlowReduxAction {
  return {
    type: EditFlow,
    flow
  };
}
